<template>
    <div class="flex items-center space-x-12">
        <label class="w-1/5 font-semibold text-black">
            {{ $t('settings.interview-templates.single') }}
        </label>
        <select-dropdown
            v-model="template"
            :options="interviewTemplates"
            no-auto-sort
            :placeholder="$t('jobs.no_template_selected')"
            class="grow"
        />

        <slot></slot>
    </div>
</template>

<script>
import * as interviewTemplateService from "../../services/InterviewTemplateService";
import InterviewTemplate from "../../models/InterviewTemplate";
import {normalizeJson} from "../../../shared/helpers";
import SelectDropdown from "../forms/SelectDropdown.vue";
import {useRepo} from 'pinia-orm';

export default {
    components: {
        SelectDropdown,
    },
    props: {
        value: null,
    },
    computed: {
        template: {
            get() {
                return this.value;
            },
            set(templateId) {
                this.$emit('input', templateId);
                this.$emit('change', templateId);
            }
        },
        interviewTemplates() {
            return useRepo(InterviewTemplate).orderBy('order').get().map(template => ({
                value: template.id,
                label: template.titleLocale,
            }));
        },
    },
    data: function () {
        return {
            fetching: true
        };
    },
    mounted() {
        return interviewTemplateService.index(true).then(result => {
            return useRepo(InterviewTemplate).save(normalizeJson(result.data));
        }).then(() => {
            this.fetching = false;
        });
    }
}
</script>

